import { get } from 'lodash'
import { useQuery } from 'react-query'
import { AxiosError } from 'axios'

import { fetchAPI } from '@/lib/api'

import { Post } from '../types'
import { Meta } from '@/features/filters/types'

import { POSTS } from '../constants'

type PostResponse = {
  data: Post[]
  meta: Meta
}

const getPosts = async (params: Meta): Promise<PostResponse> => {
  const response = await fetchAPI({
    path: `/posts`,
    params,
  })

  const data = get(response, 'data.posts', [])
  const meta = get(response, 'data.meta', {})

  return { data, meta }
}

export const usePosts = ({
  params = {},
  initialData,
}: {
  params?: Meta
  initialData?: PostResponse
}) => {
  return useQuery<PostResponse, AxiosError>({
    queryKey: [POSTS, params],
    queryFn: () => getPosts(params),
    keepPreviousData: true,
    initialData,
  })
}
